<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r4">로디드 클래스</div>
      <el-button class="mr-l4 mr-r4" size="mini" @click="refreshLoadData"><i class="far fa-sync-alt"/></el-button>
      <el-button :disabled="!isAbleRedefine" size="mini" type="secondary" @click="redefineClasses">재정의</el-button>
    </div>
    <div class="vertical-center-box">
      <el-button size="small" class="mr-r4" @click="exportLoadedClass"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool= !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="tableData" ref="loadedClassTable" v-loading="isLoading" :column-default="columnDefault" :columns="columns" :pagination="false"
   :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;" @selection-change="changeCheckedRow" @search-change="loadedClassFilter">
   <template slot-scope="scope" slot="class-name-slot">
     <span class="link" @click="onClickClassName(scope.row, 'classDown')">{{scope.row.name}}</span>
   </template>
   <template slot-scope="scope" slot="superclass-name-slot">
     <span v-if="scope.row.superClass !== ''" class="link" @click="onClickClassName(scope.row, 'super')">{{scope.row.superClass}}</span>
     <span v-else>-</span>
   </template>
  </el-table-wrapper>
  <el-row class="mr-t10" type="flex" justify="center">
    <el-pagination class="is-background ll-table-pagination"
    @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="100"
      layout="prev, pager, next"
      :total="totalCount">
    </el-pagination>
  </el-row>
  <w-class-detail-info-popup ref="classDetailInfoPopup" :classInfoParams="classInfoParams"></w-class-detail-info-popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, cloneDeep, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import ApmConfigAPI from '@/api/config/apm/apm-info';
import MsgUtil from '@/utils/message';
import FileApi from '@/api/common/file';
import WClassDetailInfoPopup from './popup/ClassDetailInfoPopup';

export default {
  name: 'WLoadedclassInfoNode',
  components: {
    WClassDetailInfoPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      tableData: [],
      classInfoParams: {},
      loadedClassSelection: [],
      searchFilter: null,
      showSearchTool: false,
      isAbleRedefine: false,
      currentPage: 1,
      isLoadedData: false,
      isLoading: false,
      totalPages: 0,
      totalCount: 0,
      params: {
        objId: null,
      },
      columns: [
        {
          type: 'selection',
        },
        {
          prop: 'typeText',
          label: '타입',
          width: 100,
          sortable: false,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'name',
          label: '이름',
          sortable: false,
          scopedSlot: 'class-name-slot',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'superClass',
          label: '슈퍼클래스',
          sortable: false,
          scopedSlot: 'superclass-name-slot',
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'interfaces',
          label: '인터페이스',
          sortable: false,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'resource',
          label: '리소스',
          sortable: false,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WLoadedclassInfoNode') {
          this.currentPage = 1;
          this.initData();
          this.loadData(this.currentPage);
        }
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WLoadedclassInfoNode') {
          this.currentPage = 1;
          this.initData();
          this.loadData(this.currentPage);
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.totalPages = 0;
      this.totalCount = 0;
      this.isLoadedData = false;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return (isNil(value) || value === '') ? EMPTY_TEXT : value;
    },
    loadData(currentPage) {
      const params = {
        objId: this.selectedNode.obj.objId,
        page: currentPage,
      };
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      if (!isNil(this.searchFilter)) {
        this.initData();
        params.searchFilter = this.searchFilter;
      }
      ApmConfigAPI.getLoadedClassList(params).then((response) => {
        if (response.data.success) {
          if (Object.entries(response.data.data).length > 0) {
            if (!this.isLoadedData) {
              this.totalPages = response.data.data.totalPage;
              this.totalCount = response.data.data.totalPage * 100;
              this.isLoadedData = true;
            }
          }
          this.tableData = response.data.data.values;
          this.isLoading = false;
        }
      });
    },
    refreshLoadData() {
      this.handleCurrentChange(1);
    },
    handleCurrentChange(size) {
      this.currentPage = size;
      this.loadData(size);
    },
    changeCheckedRow(row) {
      this.loadedClassSelection = row;
      if (row.length > 0) {
        this.isAbleRedefine = true;
      } else {
        this.isAbleRedefine = false;
      }
    },
    redefineClasses() {
      const selectObjId = [this.selectedNode.obj.objId];
      const params = [];
      this.loadedClassSelection.forEach((item) => {
        params.push(item.name);
      });
      this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.RUN)).then(() => {
        ApmConfigAPI.executeRedefineClasses({ classNames: params, objId: selectObjId }).then((response) => {
          if (response.data.success) {
            if (response.data.data.success) {
              this.refreshLoadData();
              this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RUN, '클래스 재정의', response.data.success));
            } else {
              this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RUN, '클래스 재정의', false));
            }
          }
        }).catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RUN, '클래스 재정의', false));
        });
      }).catch(() => {});
    },
    showSearchField() {
      this.isFilterLoadedClass = !this.isFilterLoadedClass;
    },
    loadedClassFilter() {
      if (!isNil(this.$refs.loadedClassTable.getParameter().searchParams)) {
        const searchValue = this.$refs.loadedClassTable.getParameter().searchParams[0].value;
        if (searchValue.length > 0) {
          this.searchFilter = searchValue;
          this.loadData(0);
        }
      } else {
        this.searchFilter = null;
        this.currentPage = 1;
        this.initData();
        this.loadData(this.currentPage);
      }
    },
    onClickClassName(row, classType) {
      const resourceValue = row.resource;
      const loadedClassInfo = cloneDeep(row);
      let ablejarDown = false;
      let isShowDownload = true;
      if (!isNil(resourceValue) && resourceValue.length > 0) {
        const splitTxt = resourceValue.split(':');
        if (splitTxt[0] === 'jar' && splitTxt[1] === 'file') {
          ablejarDown = cloneDeep(false);
        } else {
          ablejarDown = cloneDeep(true);
        }
      } else {
        ablejarDown = cloneDeep(true);
        isShowDownload = false;
      }
      loadedClassInfo.ableClassDown = (isNil(loadedClassInfo.resource) || !(loadedClassInfo.resource.length > 0));
      loadedClassInfo.isShowDownload = isShowDownload;
      loadedClassInfo.ablejarDown = ablejarDown;
      loadedClassInfo.classType = classType;
      this.classInfoParams = cloneDeep(loadedClassInfo);
      this.$refs.classDetailInfoPopup.open();
    },
    exportLoadedClass() {
      if (!isNil(this.selectedNode)) {
        const params = {
          objId: this.selectedNode.obj.objId,
          page: this.currentPage,
        };
        ApmConfigAPI.getLoadedclassExcelName(params).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/loadedclass/index.vue